export const timeoutPromise = <T>(timeout: number, value?: T) => {
  return new Promise(res => {
    setTimeout(() => res(value), timeout)
  })
}

export const whenSlow = (
  promise: Promise<void>,
  threshold: number,
): Promise<boolean> => {
  const timeoutValue = 'timeoutValue'
  return Promise.race([timeoutPromise(threshold, timeoutValue), promise]).then(
    value => {
      return value === timeoutValue
    },
  )
}
